// general
export const NAME_LABEL = 'Name'
export const TYPE_LABEL = 'Type'
export const STATUS_LABEL = 'Status'
export const OWNERSHIP_LABEL = 'Ownership'
export const REGISTRATION_LABEL = 'Registration'
export const VRM_LABEL = 'VRM'
export const WORK_HOURS_LABEL = 'Work hours'
export const ASSIGNEE_LABEL = 'Assigned to'
export const MAKE_LABEL = 'Make'
export const MODEL_LABEL = 'Model'
export const YEAR_LABEL = 'Year'
export const RESOURCE_NOT_FOUND_MESSAGE = 'Resource not found'

// jobs
export const ENFORCE_SEQUENTIAL_TASK_COMPLETION_LABEL = 'Enforce employees to complete tasks in sequence'
export const JOB_TYPE_ERROR = 'Please select a job type'
export const JOB_TITLE_ERROR = 'Please enter a job title'
export const JOB_PRIORITY_ERROR = 'Please select a job priority'
export const JOB_TYPE_PLACEHOLDER = JOB_TYPE_ERROR
export const JOB_TITLE_PLACEHOLDER = JOB_TITLE_ERROR
export const JOB_PRIORITY_PLACEHOLDER = JOB_PRIORITY_ERROR
export const JOB_RECURRENCE_INTERVAL_PLACEHOLDER = 'Enter recurrence interval value'
export const JOB_RECURRENCE_DATES_PLACEHOLDER = 'Select dates for repeating job'
export const job_RECURRENCE_END_DATE_PLACEHOLDER = 'Select end date for a recurring job'
export const EDIT_IN_PROGRESS_JOB_REDIRECTION_MESSAGE =
  'This job is currently in progress and cannot be edited. Redirecting to jobs list...'
export const JOB_WAS_DELETED_ALERT_MESSAGE =
  'This job could not be found. It may have been removed or the URL is incorrect. Redirecting to jobs list...'
export const JOB_FORMS_MANDATORY_FIELDS_PENDING_ALERT_MESSAGE = 'Please fill in all mandatory form fields before completing the job'
export const JOB_WAS_DELETED_ALERT_TITLE = 'Job not found'
export const JOB_SAME_EMPLOYEE_ASSIGNED_ALERT_MESSAGE = 'First Employee and Delivery Employee must be different'

// schedules
export const SCHEDULE_WAS_DELETED_ALERT_MESSAGE =
  'This schedule could not be found. It may have been removed or the URL is incorrect. Redirecting to schedules list...'
export const SCHEDULE_WAS_DELETED_ALERT_TITLE = 'Schedule not found'
export const DUE_DATE_REQUIRED = 'Due date is required.'
export const DUE_DATE_FUTURE = 'Due date must be in the future.'
export const START_DATE_REQUIRED = 'Start date is required.'
export const START_DATE_FUTURE = 'Start date must be in the future.'
export const END_DATE_REQUIRED = 'End date is required.'
export const SET_START_DATE_FIRST = 'Start date must be set first.'
export const INVALID_END_DATE_FORMAT = 'Invalid end date format.'
export const INVALID_START_DATE_FORMAT = 'Invalid start date format.'
export const END_DATE_AFTER_START = 'End date must be after start date.'
export const SELECT_WEEKDAY = 'At least one day must be selected.'
export const SELECT_MONTH_DATE = 'At least one date must be selected.'
export const SELECT_YEARLY_DATE = 'At least one date must be selected.'
export const REPEAT_AFTER_REQUIRED = 'Repeat after is required.'
export const REPEAT_EVERY_REQUIRED = 'Repeat in every is required.'
export const OCCURRENCES_MIN_ONE = 'Number of occurrences must be at least 1.'
export const VALID_NUMBER_REQUIRED_MSG = 'Please enter a valid number'
export const VALUE_GREATER_THAN_ZERO = 'Value must be greater than 0'
export const VALUE_GREATER_THAN_CURRENT_READING = 'Value must be greater than current reading'
export const END_AT_GREATER_THAN_CURRENT_READING = 'End at must be greater than current reading'
export const VALUE_GREATER_THAN_CURRENT_HOURS = 'Value must be greater than current hours'
export const END_AT_GREATER_THAN_CURRENT_HOURS = 'End at must be greater than current hours'
export const VALUE_AT_LEAST_TWO = 'Value must be at least 2'

// task templates
export const TASK_SHEET_WAS_DELETED_ALERT_MESSAGE =
  'This form could not be found. It may have been removed or the URL is incorrect. Redirecting to forms list...'
export const TASK_SHEET_WAS_DELETED_ALERT_TITLE = 'Form not found'
export const TEMPLATE_EMPLOYEE_ASSIGNMENT_ERROR = (count: number) =>
  `Please assign ${count} employee${count === 1 ? '' : 's'} to the form fields`

// employees
export const EMPLOYEE_TYPE_PLACEHOLDER = 'Select role'
export const EMPLOYEE_NAME_PLACEHOLDER = 'eg. John Doe'
export const EMPLOYEE_TEAM_PLACEHOLDER = 'Select team'
export const EMPLOYEE_EMAIL_PLACEHOLDER = 'eg. john@example.com'
export const EMPLOYEE_PHONE_PLACEHOLDER = 'eg. 7234684734'
export const EMPLOYEE_ADDRESS_LINE_1 = 'Enter employee address line 1'
export const EMPLOYEE_ADDRESS_LINE_2 = 'Enter employee address line 2'
export const EMPLOYEE_CITY_PLACEHOLDER = 'eg. London'
export const EMPLOYEE_STATE_PLACEHOLDER = 'eg. Yorkshire'
export const EMPLOYEE_COUNTRY_PLACEHOLDER = 'eg. United Kingdom'
export const EMPLOYEE_POSTCODE_PLACEHOLDER = 'eg. YE743H'
export const EMPLOYEE_NEXT_OF_KIN_NAME_PLACEHOLDER = 'eg. Jane Doe'
export const EMPLOYEE_NEXT_OF_KIN_EMAIL_PLACEHOLDER = 'eg. jane@example.com'
export const EMPLOYEE_NEXT_OF_KIN_PHONE_PLACEHOLDER = 'eg. 8743742834'
export const EMPLOYEE_JOB_TITLE_PLACEHOLDER = 'eg. Driver'
export const EMPLOYEE_DOB_PLACEHOLDER = "Select employee's Date of Birth"
export const EMPLOYEE_NUMBER_PLACEHOLDER = 'Enter employee number'
export const EMPLOYEE_WAS_DELETED_ALERT_MESSAGE =
  'This employee could not be found. They may have been removed or the URL is incorrect. Redirecting to employees list...'
export const EMPLOYEE_WAS_DELETED_ALERT_TITLE = 'Employee not found'

// vehicles
export const VEHICLE_NAME_PLACEHOLDER = 'Please enter a vehicle name'
export const VEHICLE_TYPE_PLACEHOLDER = 'Please select a vehicle type'
export const VEHICLE_MAKE_PLACEHOLDER = 'Please specify vehicle make'
export const VEHICLE_MODEL_PLACEHOLDER = 'Please specify vehicle model'
export const VEHICLE_YEAR_PLACEHOLDER = 'Please select a year of manufacture'
export const VEHICLE_FUEL_PLACEHOLDER = 'Please select a fuel type'
export const VEHICLE_STATUS_PLACEHOLDER = 'Please select a vehicle status'
export const VEHICLE_OWNERSHIP_PLACEHOLDER = 'Please select a vehicle ownership'
export const VEHICLE_WAS_DELETED_ALERT_MESSAGE =
  'This vehicle could not be found. It may have been removed or the URL is incorrect. Redirecting to vehicles list...'
export const ASSOCIATED_VEHICLE_WAS_DELETED_ALERT_MESSAGE = 'Reassign vehicle'

// machines
export const MACHINE_NAME_PLACEHOLDER = 'Please enter a machine name'
export const MACHINE_TYPE_PLACEHOLDER = 'Please select a machine type'
export const MACHINE_MAKE_PLACEHOLDER = 'Please specify machine make'
export const MACHINE_MODEL_PLACEHOLDER = 'Please specify machine model'
export const MACHINE_YEAR_PLACEHOLDER = 'Please select a year of manufacture'
export const MACHINE_FUEL_PLACEHOLDER = 'Please select a fuel type'
export const MACHINE_STATUS_PLACEHOLDER = 'Please select a machine status'
export const MACHINE_OWNERSHIP_PLACEHOLDER = 'Please select a machine ownership'
export const MACHINE_WAS_DELETED_ALERT_MESSAGE =
  'This machine could not be found. It may have been removed or the URL is incorrect. Redirecting to machines list...'
export const ASSOCIATED_MACHINE_WAS_DELETED_ALERT_MESSAGE = 'Reassign machine'

// inspections
export const INSPECTION_TITLE_PLACEHOLDER = 'Enter inspection title'
export const INSPECTION_DESCRIPTION_PLACEHOLDER = 'Enter inspection description here...'
export const INSPECTION_PRIORITY_PLACEHOLDER = 'Select inspection priority'
export const INSPECTION_START_PLACEHOLDER = 'Select inspection start date'
export const INSPECTION_END_PLACEHOLDER = 'Select inspection end date'
export const INSPECTION_WAS_DELETED_ALERT_MESSAGE =
  'This inspection could not be found. It may have been removed or the URL is incorrect. Redirecting to inspections list...'
export const INSPECTION_WAS_DELETED_ALERT_TITLE = 'Inspection not found'


// issues
export const ISSUE_TITLE_PLACEHOLDER = 'eg. Brake issue'
export const ISSUE_DESCRIPTION_PLACEHOLDER = 'Provide a description of the issue here...'
export const ISSUE_PRIORITY_PLACEHOLDER = 'Select issue priority'
export const ISSUE_START_PLACEHOLDER = 'Select issue start date'
export const ISSUE_END_PLACEHOLDER = 'Select issue end date'
export const ISSUE_WAS_DELETED_ALERT_MESSAGE =
  'This issue could not be found. It may have been removed or the URL is incorrect. Redirecting to issues list...'
export const ISSUE_WAS_DELETED_ALERT_TITLE = 'Issue not found'

// services
export const SERVICE_TITLE_PLACEHOLDER = 'Enter name for service'
export const SERVICE_DESCRIPTION_PLACEHOLDER = 'Describe the service in further detail here...'
export const SERVICE_PRIORITY_PLACEHOLDER = "Select service's priority level"
export const SERVICE_ODOMETER_READING_PLACEHOLDER = 'Enter current odometer reading'
export const SERVICE_NUMBER_OF_HOURS_PLACEHOLDER = 'Enter no. of hours worked'
export const SERVICE_START_PLACEHOLDER = 'Select service start date'
export const SERVICE_END_PLACEHOLDER = 'Select service end date'
export const SERVICE_RECURRENCE_END_DATE_PLACEHOLDER = 'Select end date for a recurring service'
export const SERVICE_RECURRENCE_LIMIT_PLACEHOLDER =
  'Enter occurrence limit after which service is disabled'
export const SERVICE_WAS_DELETED_ALERT_MESSAGE =
  'This service could not be found. It may have been removed or the URL is incorrect. Redirecting to services list...'
export const SERVICE_WAS_DELETED_ALERT_TITLE = 'Service not found'

// purchase orders
export const PURCHASE_ORDER_WAS_DELETED_ALERT_MESSAGE =
  'This purchase order could not be found. It may have been removed or the URL is incorrect. Redirecting to purchase orders list...'
export const PURCHASE_ORDER_WAS_DELETED_ALERT_TITLE = 'Purchase order not found'

// equipments
export const EQUIPMENT_TITLE_PLACEHOLDER = 'Please enter a equipment name'
export const EQUIPMENT_MAKE_PLACEHOLDER = 'Please enter a equipment make'
export const EQUIPMENT_MODEL_PLACEHOLDER = 'Please enter a equipment model'
export const EQUIPMENT_YEAR_PLACEHOLDER = 'Please enter a equipment year'
export const EQUIPMENT_TYPE_PLACEHOLDER = 'Please select a equipment type'
export const EQUIPMENT_STATUS_PLACEHOLDER = 'Please select a equipment status'
export const EQUIPMENT_OWNERSHIP_PLACEHOLDER = 'Please select a equipment ownership'
export const EQUIPMENT_ASSIGNEE_PLACEHOLDER = 'Pelase select an employee'
export const EQUIPMENT_WORK_HOURS_PLACEHOLDER = 'Please enter equipment machine hours'
export const EQUIPMENT_FRONT_TRACK_WIDTH_PLACEHOLDER = 'Please enter equipment front track width'
export const EQUIPMENT_REAR_TRACK_WIDTH_PLACEHOLDER = 'Please enter equipment rear track width'
export const EQUIPMENT_WHEELBASE_PLACEHOLDER = 'Please enter equipment wheelbase'
export const EQUIPMENT_FRONT_WHEEL_DIAMETER_PLACEHOLDER =
  'Please enter equipment front wheel diameter'
export const EQUIPMENT_REAR_WHEEL_DIAMETER_PLACEHOLDER =
  'Please enter equipment rear wheel diameter'
export const EQUIPMENT_REAR_AXEL_PLACEHOLDER = 'Please enter equipment rear axle'
export const EQUIPMENT_FRONT_TYRE_TYPE_PLACEHOLDER = 'Please enter equipment front tyre type'
export const EQUIPMENT_FRONT_TYRE_PSI_PLACEHOLDER = 'Please enter equipment front tyre PSI'
export const EQUIPMENT_REAR_TYRE_TYPE_PLACEHOLDER = 'Please enter equipment rear tyre type'
export const EQUIPMENT_REAR_TYRE_PSI_PLACEHOLDER = 'Please enter equipment rear tyre PSI'
export const EQUIPMENT_WAS_DELETED_ALERT_MESSAGE =
  'This equipment could not be found. It may have been removed or the URL is incorrect. Redirecting to equipments list...'
export const ASSOCIATED_EQUIPMENT_WAS_DELETED_ALERT_MESSAGE = 'Reassign equipment'
// vendors
export const VENDOR_TITLE_PLACEHOLDER = 'Enter title'
export const VENDOR_CATEGORY_PLACEHOLDER = 'Select category'
export const VENDOR_PHONE_NUMBER_PLACEHOLDER = 'Enter phone number'
export const VENDOR_WEBSITE_PLACEHOLDER = 'Enter website'
export const VENDOR_NOTES_PLACEHOLDER = 'Enter notes here'
export const VENDOR_ADDRESS_PLACEHOLDER = 'Enter address'
export const VENDOR_CITY_PLACEHOLDER = 'Enter city'
export const VENDOR_STATE_PLACEHOLDER = 'Enter state'
export const VENDOR_COUNTRY_PLACEHOLDER = 'Enter country'
export const VENDOR_POSTCODE_PLACEHOLDER = 'Enter postcode'
export const VENDOR_CONTACT_PERSON_NAME_PLACEHOLDER = 'Enter contact person name'
export const VENDOR_CONTACT_PERSON_PHONE_NUMBER_PLACEHOLDER = 'Enter contact person phone number'
export const VENDOR_CONTACT_PERSON_EMAIL_PLACEHOLDER = 'Enter email address'
export const VENDOR_WAS_DELETED_ALERT_MESSAGE =
  'This vendor could not be found. It may have been removed or the URL is incorrect. Redirecting to vendors list...'

// service programmes
export const SERVICE_PROGRAMME_TITLE_PLACEHOLDER = 'Enter service programme name'
export const SERVICE_PROGRAMME_DESCRIPTION_PLACEHOLDER =
  'Provide service programme description here...'
export const SERVICE_PROGRAMME_DUE_IN_PLACEHOLDER =
  'Enter value after which service programme is active'
export const SERVICE_PROGRAMME_START_PLACEHOLDER = 'Select date when the programme is active'
export const SERVICE_PROGRAMME_END_PLACEHOLDER = 'Select date when the programme should end'
export const SERVICE_PROGRAMME_RECURRENCE_END_DATE_PLACEHOLDER =
  'Select end date for a recurring service programme'
export const SERVICE_PROGRAMME_RECURRENCE_LIMIT_PLACEHOLDER =
  'Enter occurrence limit after which service programme is disabled'

// service tasks
export const SERVICE_TASK_TITLE_PLACEHOLDER = 'Enter service task name'
export const SERVICE_TASK_DESCRIPTION_PLACEHOLDER = 'Provide description for service task here...'
export const SERVICE_TASK_WORK_TIME_PLACEHOLDER = 'Enter work hour for service task'
export const SERVICE_TASK_WAS_DELETED_ALERT_MESSAGE =
  'This service task could not be found. It may have been removed or the URL is incorrect. Redirecting to service tasks list...'

// rules
export const REQUIRED_RULE = 'Field is required'
export const NUMBER_RULE = 'Value has to be a number'
export const VALID_NUMBER_REQUIRED = 'Please enter a valid number'
export const GREATER_THAN_PREVIOUS_RULE = 'Value must be greater than'
export const GREATER_THAN_ZERO_RULE = 'Value must be greater than 0'
export const GREATER_THAN_OR_EQUALS_PREVIOUS_RULE =
  'Value must be greater than or equal to previous value of'
export const NUMBER_POSITIVE_RULE = 'Value must be greater than 0'
export const INTEGER_RULE = 'Value cannot be a decimal'
export const PHONE_NUMBER_RULE = 'Please enter a valid phone number'
export const MAXIMUM_DECIMAL_PLACES_RULE = 'Value can have maximum of 2 decimal places'
export const MINIMUM_FUEL_QUANTITY_RULE = 'Minimum fuel quantity is 0.5'
export const USERNAME_VALIDATION_REQUIRED_RULE = 'Username is required.'
export const USERNAME_VALIDATION_FORMAT_RULE = 'Username cannot contain symbols.'
export const EMAIL_VALIDATION_REQUIRED_RULE = 'Email is required.'
export const EMAIL_VALIDATION_FORMAT_RULE = 'Incorrect email format.'
export const PASSWORD_VALIDATION_REQUIRED_RULE = 'Password is required.'
export const CONFIRM_PASSWORD_REQUIRED_RULE = 'Confirm password is required.'
export const EQUAL_PASSWORD_VALIDATION_RULE = 'Passwords do not match'
export const EMAIL_VALID_FORMAT_RULE = 'Incorrect email format'
export const EMAIL_NOT_EMPTY_RULE = 'Email cannot be empty'
export const FIRST_NAME_NOT_EMPTY_RULE = 'First name cannot be empty'
export const DISPLAY_NAME_NOT_EMPTY_RULE = 'Display name cannot be empty'
export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters',
  'At least 1 uppercase letter',
  'At least 1 lowercase letter',
  'At least 1 number',
  'At least 1 special character'
]
export const URL_VALIDATION_FORMAT_RULE = 'Incorrect URL format.'

// assets
export const VEHICLE_NOT_FOUND_TITLE_ALERT = 'Vehicle not found'
export const MACHINE_NOT_FOUND_TITLE_ALERT = 'Machine not found'
export const EQUIPMENT_NOT_FOUND_TITLE_ALERT = 'Equipment not found'
export const DELETED_VEHICLE_ASSET_ALERT = 'Vehicle not found. Please assign another.'
export const DELETED_EQUIPMENT_ASSET_ALERT = 'Equipment not found. Please assign another.'
export const DELETED_MACHINE_ASSET_ALERT = 'Machine not found. Please assign another.'
export const DELETED_ASSET_ALERT = 'This asset has been deleted. Please assign another before proceeding.'